/* eslint-disable @typescript-eslint/no-explicit-any */
// import React from 'react';
import { Row } from '@tanstack/react-table'; // CellContext
import { flexRender } from '@tanstack/react-table';

interface TableRowProps<T> {
  row: Row<T>;
  index: number;
  selectedRowId: string | null;
  onRowClick: (id: string | undefined) => void;
  className?: string;
}

export const TableRow = <T extends object>({
  row,
  index,
  selectedRowId,
  onRowClick,
  className = 'px-3 py-2 whitespace-nowrap text-sm text-brand-gray-dark',
}: TableRowProps<T>) => {
  const handleRowClick = () => {
    // TODO: Remove this once we have a proper type for the object
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const id = (row.original as any)._id;
    onRowClick(id);
  };

  return (
    <tr
      onClick={handleRowClick}
      // TODO: Remove this once we have a proper type for the object
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      className={`
        ${index % 2 === 0 ? 'bg-white' : 'bg-gray-100'}
        cursor-pointer
        hover:bg-brand-orange hover:bg-opacity-30
        ${selectedRowId === (row.original as any)._id ? '!bg-brand-orange !bg-opacity-75' : ''}
      `}
    >
      {row.getVisibleCells().map((cell) => (
        <td key={cell.id} className={className}>
          {flexRender(cell.column.columnDef.cell, cell.getContext())}
        </td>
      ))}
    </tr>
  );
};
